import type { TextFieldProps } from '@liquidweb-dev/undercurrent/TextField';
import ListSubheader from '@liquidweb-dev/undercurrent/ListSubheader';
import MenuItem from '@liquidweb-dev/undercurrent/MenuItem';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import useAssetCancellationReasonList from 'modules/queries/asset/cancellation/useReasonList';
import HookedTextField from 'components/Form/HookedTextField';

export type ReasonListProps = TextFieldProps & {
	/** When the reasons are fetched. Defaults to true. */
	isQueryEnabled?: boolean;
};

const ReasonList = ({ isQueryEnabled = true, ...props }: ReasonListProps) => {
	const { isLoading: isReasonsLoading, data: cancellationReasons } =
		useAssetCancellationReasonList({ enabled: isQueryEnabled });

	return (
		<HookedTextField
			name="cancellation_reason"
			label="Reason for cancellation"
			size="medium"
			fullWidth
			select
			disabled={isReasonsLoading}
			slotProps={{
				select: {
					displayEmpty: true,
				},
			}}
			{...props}
		>
			<MenuItem value="" disabled sx={{ display: 'none' }}>
				Select a reason
			</MenuItem>
			{cancellationReasons?.map((data) => {
				if (data.type === 'category') {
					return (
						<ListSubheader
							sx={{ backgroundColor: 'transparent' }}
							key={data.label}
						>
							<Typography variant="label-xl" sx={{ fontWeight: 500 }}>
								{data.label}
							</Typography>
						</ListSubheader>
					);
				}

				return (
					<MenuItem key={data.label} value={data.label}>
						<Typography
							variant="label-xl"
							sx={{
								fontWeight: 400,
								lineHeight: '24px',
								whiteSpace: 'normal',
							}}
						>
							{data.label}
						</Typography>
					</MenuItem>
				);
			})}
		</HookedTextField>
	);
};

export default ReasonList;
